//created by Peggy on 2021/3/11
import React from "react";
import styled from "styled-components";

import CardItem from "@/pages/dashboard/income/CardItem";
import { Pie } from "@ant-design/charts";
import { ReactComponent as NoData } from "@/images/icon_stat.svg";
import { useModel } from "use-reaction";
import { view } from "@/model/view";
import { useSize } from "react-use";

const PieCardContainer = styled.div`
  position: relative;
  .legend-title {
    position: absolute;
    top: 110px;
    left: 210px;
    font-size: 13px;
    font-weight: 700;
    width: calc(100% - 220px);
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media screen and (max-width: 1023px) {
      top: 90px;
      left: 28px;
      width: calc(100% - 16px);
    }
  }
  .no-data {
    h4{
      line-height: 24px !important;
    }
`;

interface Props {
  data: any[];
}

function formatValue(value: number) {
  return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const PieCard = ({ data = [] }: Props) => {
  const sumValue = data.reduce((sum, cur) => sum + cur.value, 0);
  const [sized, {width}] = useSize(()=><div></div>);
  console.log(width)


  const {
    store: { isMobile },
  } = useModel(view);
  //pie config
  const pie: any = {
    width: 525,
    height: isMobile ? 530 : 226,
    autoFit: false,
    padding: [30, 320, 30, 16],
    appendPadding: 0,
    data,
    angleField: "value",
    colorField: "type",
    color: ["#FF7456", "#25F2FF", "#B455FF", "#AEDD29"],
    radius: 1,
    innerRadius: 0.72,
    renderer: "svg",
    statistic: {
      title: false,
      content: false,
    },
    state: {
      active: {
        style: {
          lineWidth: 0,
          fillOpacity: 0.7,
        },
      },
    },
    meta: {
      value: {
        formatter: function formatter(v: any) {
          const _v = v?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return "$ ".concat(_v);
        },
      },
    },
    label: false,
    interactions: [{ type: "element-active" }],
    legend: {
      position: "left",
      flipPage: false,
      offsetX: isMobile ? 20 : 202,
      offsetY: isMobile ? -168 : 0,
      maxItemWidth:  width - (isMobile ? 20 : 240),
      itemHeight: 24,
      itemValue: {
        formatter: (text: string, item: any, index: number) => {
          return  ` ... $${data[index].value?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        },
      },
    },
  };

  return (
    <PieCardContainer className="pie-card-container flex-1">
      <CardItem title="Income overview">
        {data.reduce((v, cur) => v + cur.value, 0) > 0 ? (
          <>
            <Pie {...pie} />
            <p className="legend-title">Total ${formatValue(sumValue)} Raised</p>
          </>
        ) : (
          <div className="no-data">
            <NoData />
            <h4>No statistic yet</h4>
            <p> Set up your profile, get funded, and start seeing valuable insights{" "} </p>
          </div>
        )}
      </CardItem>
      {sized}
    </PieCardContainer>
  );
};

export default React.memo(PieCard);
